/**
 * Summary of a Pro's payouts.
 */
export interface ProPayoutSummary {
  earningsYearToDate: number
  pendingEarnings: number
  lifetimeEarnings: number
}

export const ProPayoutSummary = {
  /**
   * Returns a default value for the pro payout summary.
   */
  default(): ProPayoutSummary {
    return {
      pendingEarnings: 0,
      lifetimeEarnings: 0,
      earningsYearToDate: 0,
    }
  },
}
